import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import FeatherIcon from "feather-icons-react";
import axios from "axios";
import { toast } from "react-toastify";

class ArchiveForm extends Component {
    state = {
        sectionclasseId: "",
        sectionclasses: [],
        loading: false,
        submitting: false,
        confirmationModalOpen: false,
        confirmationText: "",
        error: ""
    };

    getStudents = () => Array.isArray(this.props.formData) ? this.props.formData : [];

    getStudentName = (student) => [
        student?.user?.last_name,
        student?.user?.family_name,
        student?.user?.first_name || student?.user?.fist_name
    ].filter(Boolean).join(" ") || "Élève sans nom";

    getClassLabel = (sectionclasse) => [
        sectionclasse?.class?.short_entitled_class,
        sectionclasse?.title,
        sectionclasse?.section?.short_entitled_section || sectionclasse?.section?.entitled_section
    ].filter(Boolean).join(" · ");

    getConfirmationPhrase = (sectionclasse, studentCount) => {
        if (!sectionclasse || !studentCount) return "";
        const destination = [
            sectionclasse?.class?.short_entitled_class,
            sectionclasse?.title
        ].filter(Boolean).join(" ") || this.getClassLabel(sectionclasse);
        return `CONFIRMER ${studentCount} ELEVE${studentCount > 1 ? "S" : ""} EN ${destination.toLocaleUpperCase("fr-FR").replace(/\s+/g, " ").trim()}`;
    };

    handleInput = (option) => {
        this.setState({
            sectionclasseId: option?.value || "",
            confirmationText: "",
            error: ""
        });
    };

    handleConfirmationInput = (event) => {
        this.setState({ confirmationText: event.target.value.toLocaleUpperCase("fr-FR"), error: "" });
    };

    openConfirmationModal = () => {
        if (!this.getStudents().length || !this.state.sectionclasseId) {
            this.setState({ error: "Sélectionnez une classe d’accueil avant de continuer." });
            return;
        }

        this.setState({ confirmationModalOpen: true, confirmationText: "", error: "" });
    };

    closeConfirmationModal = () => {
        if (this.state.submitting) return;
        this.setState({ confirmationModalOpen: false, confirmationText: "", error: "" });
    };

    storeStudents = async () => {
        const students = this.getStudents();
        const studentId = students.map((student) => student.id).filter(Boolean);

        if (!studentId.length || !this.state.sectionclasseId) {
            this.setState({ error: "Sélectionnez une classe d’accueil avant de continuer." });
            return;
        }

        const selectedClass = this.state.sectionclasses.find(
            (sectionclasse) => String(sectionclasse.id) === String(this.state.sectionclasseId)
        );
        const expectedConfirmation = this.getConfirmationPhrase(selectedClass, students.length);
        if (this.state.confirmationText.trim() !== expectedConfirmation) {
            this.setState({ error: "Recopiez exactement la phrase de confirmation avant de continuer." });
            return;
        }

        this.setState({ submitting: true, error: "" });
        try {
            const response = await axios.post("studentnextclass", {
                studentId,
                sectionclasseId: this.state.sectionclasseId
            });
            toast(response?.data?.msg || "Le passage en classe supérieure a été enregistré.", {
                theme: "light",
                style: { backgroundColor: "blue", color: "white" }
            });
            this.setState({ confirmationModalOpen: false });
            this.props.showModal(1);
        } catch (error) {
            const message = error.response?.data?.msg || "Le passage n’a pas pu être enregistré. Réessayez.";
            this.setState({ submitting: false, error: message });
            toast(message, {
                theme: "light",
                style: { backgroundColor: "red", color: "white" }
            });
        }
    };

    getSectionclasses = async () => {
        this.setState({ loading: true, error: "" });
        try {
            const request = await axios.get("sectionclasses");
            this.setState({
                sectionclasses: request.status === 200 && Array.isArray(request.data) ? request.data : [],
                loading: false
            });
        } catch (error) {
            this.setState({ loading: false, error: "Impossible de charger les classes disponibles." });
        }
    };

    edit = () => {
        this.setState({
            sectionclasseId: "",
            sectionclasses: [],
            submitting: false,
            confirmationModalOpen: false,
            confirmationText: "",
            error: ""
        }, this.getSectionclasses);
    };

    render() {
        const students = [...this.getStudents()].sort((first, second) =>
            this.getStudentName(first).localeCompare(this.getStudentName(second), "fr")
        );
        const selectedClass = this.state.sectionclasses.find(
            (sectionclasse) => String(sectionclasse.id) === String(this.state.sectionclasseId)
        );
        const classOptions = [...this.state.sectionclasses]
            .sort((first, second) => this.getClassLabel(first).localeCompare(
                this.getClassLabel(second),
                "fr",
                { numeric: true, sensitivity: "base" }
            ))
            .map((sectionclasse) => ({
                value: sectionclasse.id,
                label: this.getClassLabel(sectionclasse)
            }));
        const selectedClassOption = classOptions.find(
            (option) => String(option.value) === String(this.state.sectionclasseId)
        ) || null;
        const confirmationPhrase = this.getConfirmationPhrase(selectedClass, students.length);
        const confirmationMatches = Boolean(
            confirmationPhrase && this.state.confirmationText.trim() === confirmationPhrase
        );
        const canOpenConfirmation = Boolean(students.length && selectedClass && !this.state.submitting);
        const canSubmit = Boolean(confirmationMatches && !this.state.submitting);

        const selectMenuProps = {
            menuPortalTarget: typeof document !== "undefined" ? document.body : null,
            menuPosition: "fixed",
            classNamePrefix: "student-select",
            styles: { menuPortal: (base) => ({ ...base, zIndex: 1060 }) },
        };

        return (
            <Modal
                show={this.props.isModal}
                onHide={this.props.showModal}
                size="lg"
                dialogClassName="rh-archive-move"
                contentClassName="rh-archive-move__content"
                onEntered={this.edit}
                backdrop="static"
                centered
            >
                <Modal.Header>
                    <div className="rh-archive-move__heading">
                        <span className="rh-archive-move__heading-icon">
                            <FeatherIcon icon="trending-up" size={21} />
                        </span>
                        <div>
                            <span className="rh-archive-move__eyebrow">Passage scolaire</span>
                            <Modal.Title>Passer en classe supérieure</Modal.Title>
                            <p>Affectez les élèves sélectionnés à leur prochaine classe.</p>
                        </div>
                    </div>
                    <span className="rh-archive-move__count">
                        <strong>{students.length}</strong>
                        élève{students.length > 1 ? "s" : ""}
                    </span>
                </Modal.Header>

                <Modal.Body>
                    {this.state.error && (
                        <div className="rh-archive-move__alert" role="alert">
                            <FeatherIcon icon="alert-circle" size={18} />
                            <span>{this.state.error}</span>
                        </div>
                    )}

                    <div className="rh-archive-move__flow" aria-label="Étapes du passage">
                        <div className="is-complete">
                            <span><FeatherIcon icon="users" size={17} /></span>
                            <div><strong>Élèves</strong><small>{students.length} sélectionné{students.length > 1 ? "s" : ""}</small></div>
                        </div>
                        <i><FeatherIcon icon="arrow-right" size={18} /></i>
                        <div className={selectedClass ? "is-complete" : "is-current"}>
                            <span><FeatherIcon icon="book-open" size={17} /></span>
                            <div><strong>Classe d’accueil</strong><small>{selectedClass ? "Sélectionnée" : "À choisir"}</small></div>
                        </div>
                        <i><FeatherIcon icon="arrow-right" size={18} /></i>
                        <div className={selectedClass ? "is-current" : ""}>
                            <span><FeatherIcon icon="check" size={17} /></span>
                            <div><strong>Confirmation</strong><small>Dernière étape</small></div>
                        </div>
                    </div>

                    <div className="rh-archive-move__grid">
                        <section className="rh-archive-move__panel">
                            <header>
                                <span><FeatherIcon icon="user-check" size={17} /></span>
                                <div><strong>Élèves concernés</strong><small>Vérifiez la sélection avant le passage</small></div>
                            </header>
                            <div className="rh-archive-move__students">
                                {students.map((student, index) => {
                                    const name = this.getStudentName(student);
                                    const classeSection = this.getClassLabel(student?.sectionclass);
                                    const initials = name.split(" ").slice(0, 2).map((part) => part.charAt(0)).join("");
                                    return (
                                        <div className="rh-archive-move__student" key={student.id || index}>
                                            <span className="rh-archive-move__avatar">{initials}</span>
                                            <div><strong>{name}</strong><small>{student.matricule || `Élève ${index + 1}`}</small></div>
                                            <small>{ classeSection }</small><FeatherIcon icon="check-circle" size={17} />
                                        </div>
                                    );
                                })}
                            </div>
                        </section>

                        <section className="rh-archive-move__panel rh-archive-move__destination">
                            <header>
                                <span><FeatherIcon icon="navigation" size={17} /></span>
                                <div><strong>Nouvelle affectation</strong><small>Choisissez la classe pour l’année suivante</small></div>
                            </header>

                            <label htmlFor="archive-next-class">Classe d’accueil <b>*</b></label>
                            <div className="rh-archive-move__select">
                                <FeatherIcon icon="layers" size={17} />
                                <Select {...selectMenuProps}
                                    className="form-control form-control-sm p-0"
                                    inputId="archive-next-class"
                                    classNamePrefix="rh-archive-class-select"
                                    value={selectedClassOption}
                                    options={classOptions}
                                    name="sectionclasseId"
                                    onChange={this.handleInput}
                                    isDisabled={this.state.loading || this.state.submitting}
                                    isLoading={this.state.loading}
                                    isClearable
                                    isSearchable
                                    placeholder={this.state.loading ? "Chargement des classes…" : "Rechercher ou sélectionner une classe"}
                                    noOptionsMessage={() => "Aucune classe trouvée"}
                                    loadingMessage={() => "Chargement des classes…"}
                                />
                            </div>

                            {selectedClass ? (
                                <div className="rh-archive-move__selected">
                                    <span><FeatherIcon icon="award" size={21} /></span>
                                    <div>
                                        <small>Destination choisie</small>
                                        <strong>{this.getClassLabel(selectedClass)}</strong>
                                        <p>{students.length} élève{students.length > 1 ? "s" : ""} y {students.length > 1 ? "seront affectés" : "sera affecté"}.</p>
                                    </div>
                                </div>
                            ) : (
                                <div className="rh-archive-move__placeholder">
                                    <FeatherIcon icon="mouse-pointer" size={22} />
                                    <span>La classe choisie apparaîtra ici pour vérification.</span>
                                </div>
                            )}

                        </section>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button type="button" onClick={this.props.showModal} className="btn btn-light rh-archive-move__button" disabled={this.state.submitting}>
                        <FeatherIcon icon="x" size={16} /> Annuler
                    </button>
                    <button type="button" onClick={this.openConfirmationModal} className="btn btn-primary rh-archive-move__button" disabled={!canOpenConfirmation}>
                        <FeatherIcon icon="arrow-up-circle" size={17} /> Confirmer le passage
                    </button>
                </Modal.Footer>

                <Modal
                    show={this.state.confirmationModalOpen}
                    onHide={this.closeConfirmationModal}
                    dialogClassName="rh-archive-confirm"
                    contentClassName="rh-archive-confirm__content"
                    backdrop="static"
                    centered
                >
                    <Modal.Header>
                        <div className="rh-archive-confirm__heading">
                            <span><FeatherIcon icon="alert-triangle" size={20} /></span>
                            <div>
                                <Modal.Title>Action irréversible</Modal.Title>
                                <p>Vérifiez une dernière fois avant de valider le passage.</p>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.error && (
                            <div className="rh-archive-move__alert" role="alert">
                                <FeatherIcon icon="alert-circle" size={18} />
                                <span>{this.state.error}</span>
                            </div>
                        )}
                        <div className="rh-archive-move__notice rh-archive-move__notice--danger">
                            <FeatherIcon icon="alert-triangle" size={17} />
                            <span><strong>Action irréversible.</strong> Le passage modifiera définitivement la classe actuelle de tous les élèves sélectionnés.</span>
                        </div>
                        <div className="rh-archive-move__confirmation">
                            <label htmlFor="archive-confirmation">Pour confirmer, recopiez exactement :</label>
                            <code>{confirmationPhrase}</code>
                            <input
                                id="archive-confirmation"
                                type="text"
                                value={this.state.confirmationText}
                                onChange={this.handleConfirmationInput}
                                placeholder={confirmationPhrase}
                                autoComplete="off"
                                spellCheck="false"
                                disabled={this.state.submitting}
                                aria-describedby="archive-confirmation-help"
                                autoFocus
                            />
                            <small id="archive-confirmation-help">Le bouton restera verrouillé tant que la phrase ne correspond pas.</small>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" onClick={this.closeConfirmationModal} className="btn btn-light rh-archive-move__button" disabled={this.state.submitting}>
                            <FeatherIcon icon="x" size={16} /> Annuler
                        </button>
                        <button type="button" onClick={this.storeStudents} className="btn btn-danger rh-archive-move__button" disabled={!canSubmit}>
                            {this.state.submitting
                                ? <><span className="spinner-border spinner-border-sm" /> Passage en cours…</>
                                : <><FeatherIcon icon="check" size={17} /> Valider</>}
                        </button>
                    </Modal.Footer>
                </Modal>
            </Modal>
        );
    }
}

export default ArchiveForm;
